
export const ZERO = BigInt(0)
export const ONE = BigInt(1)
export const SIXTY = BigInt(60)
export const THOUSAND = BigInt(1e3)
export const MILLION = BigInt(1e6)
export const BILLION = BigInt(1e9)
export const NEGATIVE_ONE = BigInt(-1)
export const DAY_SECONDS = 86400
export const DAY_NANOS = BigInt(DAY_SECONDS) * BILLION
export const NS_MIN = (BigInt(-86400) * BigInt(1e17))
export const NS_MAX = (BigInt(86400) * BigInt(1e17))
export const YEAR_MIN = -271821
export const YEAR_MAX = 275760
export const BEFORE_FIRST_OFFSET_TRANSITION = (BigInt(-388152) * BigInt(1e13)) // 1847-01-01T00:00:00Z
export const ABOUT_TEN_YEARS_NANOS = (DAY_NANOS * BigInt(366 * 10))
export const ABOUT_ONE_YEAR_NANOS = (DAY_NANOS * BigInt(366 * 1))
export const TWO_WEEKS_NANOS = (DAY_NANOS * BigInt(2 * 7))
